import CommonStatusHistory from "./CommonStatusHistory";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import HistoryIcon from "@mui/icons-material/History";
import { IconButton } from "@mui/material";
import {
  CommonStatusPopUp,
  MuiTooltip,
  timeoutCall,
} from "@pionglobal/pionsharedui";
import PropTypes from "prop-types";
import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStatusHistory } from "@features";
// ===================================================================================================

const CommonStatusAndHistory = ({
  details,
  updateApi,
  getFunction,
  historyApi = getStatusHistory,
  statusData,
  statusApi,
  optionValue,
  historyData,
  historyPayloadKey,
  showUpdateByRole,
}) => {
  const [viewStatusChange, setViewStatusChange] = useState(false);
  const [showStatusHistory, setShowStatusHistory] = useState(false);
  const dispatch = useDispatch();
  const reduxHistory = useSelector((state) => state?.statusHistory);

  const record = useMemo(() => {
    if (Array.isArray(details)) return details[0] || {};
    return details || {};
  }, [details]);

  const recordId =
    record?.id ??
    record?._id ??
    record?.leadId ??
    record?.prospectId ??
    record?.inquiryId ??
    record?.campaignId ??
    record?.opportunityId ??
    record?.accountId ??
    record?.contactId ??
    record?.customerId;

  const currentHistoryData =
    historyData !== undefined ? historyData : reduxHistory?.data;

  const handleUpdateFunction = useCallback(
    async (status) => {
      dispatch(
        updateApi?.({
          id: recordId,
          status: status,
        }),
      ).then((res) => {
        if (res?.payload?.ok) {
          getFunction?.();
          timeoutCall(() => setViewStatusChange(false));
        }
      });
    },
    [dispatch, getFunction, recordId, updateApi],
  );

  const status = useMemo(() => {
    if (!record || (Array.isArray(details) && details.length === 0)) return <></>;

    return (
      <>
        {record?.status}
        {updateApi && (
          <MuiTooltip title="Update Status">
            <IconButton
              onClick={() => {
                setViewStatusChange(true);
                statusApi?.();
              }}
              size="small"
              style={{ paddingTop: 0, paddingBottom: 0 }}
            >
              <ArrowDropDownCircleIcon
                style={{
                  color: "#06324a",
                  fontSize: "large",
                }}
              />
            </IconButton>
          </MuiTooltip>
        )}
        {historyApi && (
          <MuiTooltip title="View Status History">
            <IconButton
              onClick={() => {
                setShowStatusHistory(true);
                const payloadKey =
                  historyPayloadKey ||
                  (record?.leadId || record?.leadNo || record?.leadName ? "leadId" : "") ||
                  (record?.prospectId || record?.prospectNo || record?.prospectName ? "prospectId" : "") ||
                  (record?.inquiryId || record?.inquiryNo || record?.inquiryName ? "inquiryId" : "") ||
                  (record?.campaignId || record?.campaignNo || record?.campaignName ? "campaignId" : "") ||
                  (record?.opportunityId || record?.opportunityNo || record?.opportunityName ? "opportunityId" : "") ||
                  (record?.customerAccountId || record?.accountId || record?.accountNo ? "customerAccountId" : "") ||
                  (record?.contactId || record?.contactNo ? "contactId" : "") ||
                  (record?.customerId || record?.customerNo ? "customerId" : "") ||
                  "id";

                dispatch(
                  historyApi({
                    [payloadKey]: recordId,
                  }),
                );
              }}
              size="small"
              style={{ paddingTop: 0, paddingBottom: 0 }}
            >
              <HistoryIcon
                style={{
                  color: "#06324a",
                  fontSize: "large",
                }}
              />
            </IconButton>
          </MuiTooltip>
        )}
      </>
    );
  }, [details, dispatch, historyApi, historyPayloadKey, record, recordId, statusApi, updateApi]);

  return (
    <>
      {status}

      {viewStatusChange && (
        <CommonStatusPopUp
          data={statusData}
          optionValue={optionValue}
          close={() => setViewStatusChange(false)}
          handleUpdateFunction={(status) => handleUpdateFunction(status)}
          selectedData={record}
        />
      )}
      {showStatusHistory && (
        <CommonStatusHistory
          data={currentHistoryData}
          close={() => setShowStatusHistory(false)}
          showUpdateByRole={showUpdateByRole}
        />
      )}
    </>
  );
};

export default CommonStatusAndHistory;

CommonStatusAndHistory.propTypes = {
  details: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  updateApi: PropTypes.func,
  statusApi: PropTypes.func,
  getFunction: PropTypes.func,
  historyApi: PropTypes.func,
  statusData: PropTypes.array,
  historyData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  historyPayloadKey: PropTypes.string,
  optionValue: PropTypes.string,
  showUpdateByRole: PropTypes.bool,
};
